import React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// themes
import { BottomPaper as BottomPaperOrigin } from 'themes/views/settings'

const BottomPaper = styled((props) => <BottomPaperOrigin {...props} />)`
  && {
    margin-top: auto;
  }
`

interface Props {
  onSaveClick?: () => unknown
  onCancelClick: () => unknown
}

const BottomPaperComponent: React.FC<Props> = ({ onSaveClick, onCancelClick }) => {
  return (
    <BottomPaper square>
      <Grid container spacing={2} alignItems='flex-end'>
        <Grid>
          <Button type='submit' layout={BUTTON_LAYOUTS.PURPLE} onClick={onSaveClick}>
            Save
          </Button>
        </Grid>
        <Grid>
          <Button layout={BUTTON_LAYOUTS.WHITE} type='button' onClick={onCancelClick}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </BottomPaper>
  )
}

export default BottomPaperComponent
